Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-same-day-delivery'), wrapper;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    var model = null, cartModel = null;
    var items = [], newObj = {}, currentObj = {};
    var useCartItems= false, postalCode, countryCode = LhApp.Context.Country;

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.update = function () {
        var html = Vendd.Handlebars.parse("sameDayDeliveryWidget_A", model);

        $wrapper.html(html);

        $wrapper.on('click', '.info-btn', function (e) {
            var tooltipBox = $(this).siblings('.info-tooltip');
            tooltipBox.toggle();
        });

        $(document).on('click', function (e) {
            if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
                $('.info-tooltip', $wrapper).hide();
            }
        });

        wrapper.loading(false);
    };

    wrapper.checkSameDayDelivery = function() {
        wrapper.loading(true);

        postalCode = Cookies.get('DeliveryPostalCode');

        newObj = { "items": items, "useCartItems": useCartItems, "postalCode": postalCode, "countryCode": countryCode };

        if (items.length > 0 && JSON.stringify(newObj) != JSON.stringify(currentObj)) {
            currentObj = newObj;
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.CheckSameDayDeliveryAvailability(items, useCartItems, postalCode, countryCode));
        }
    };

    if ($('.product-details-region').length > 0) {
        Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, wrapper, function (envelope) {
            items = [];

            var item = {
                skuId: Vendd.Product.Controller.getState().selectedId,
                quantity: Vendd.Product.Controller.getState().qty
            }
            items.push(item);

            wrapper.checkSameDayDelivery();
        });
    }

    if ($('.cart-region').length > 0) {
        Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, wrapper, function (envelope) {
            cartModel = envelope.message.data.Cart;

            items = [];

            for (var i = 0; i < cartModel.Items.length; i++) {
                var item = {
                    skuId: cartModel.Items[i].VariantId,
                    quantity: cartModel.Items[i].Quantity
                }
                items.push(item);
            }

            wrapper.checkSameDayDelivery();    
        });
    }

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.CheckSameDayDeliveryAvailabilitySuccess, wrapper, function (envelope) {
        model = JSON.parse(envelope.message.data.data);

        var literals = {
            "SameDayDeliveryTag": $wrapper.data('sameday-tag-text'),
            "SameDayDeliveryTooltipHeader": $wrapper.data('sameday-tooltip-header'),
            "SameDayDeliveryTooltipText": $wrapper.data('sameday-tooltip-text')
        }

        model.Literals = literals;

        wrapper.update();
    });

});